import React, {useEffect, useState} from 'react';

const TugasHooks = () => {
  const [date, setDate] = useState(new Date())
  const [count, setCount] = useState(100)
 
  useEffect(() => {
    setInterval(()=> tick(), 1000)
  })

  const tick = () => {
    setDate(new Date())
    setCount(count-1)
  }
    
  return (
    <>
    {count > 0 && <div>
      <h2>Now At - {date.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', second:'numeric', hour12: true })}.</h2>
      <h3>Countdown: {count}</h3>
    </div>}
    </>
  );
}

export default TugasHooks